import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Quota } from '../models/quota.model';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class QuotaService {
  private apiUrl = `${environment.apiUrl}/quotas`;

  constructor(private http: HttpClient) {}

  /**
   * Get quota by enrollment ID
   */
  getQuotaByEnrollment(enrollmentId: number): Observable<ApiResponse<Quota>> {
    return this.http.get<ApiResponse<Quota>>(`${this.apiUrl}/enrollment/${enrollmentId}`);
  }

  /**
   * Get quota by ID
   */
  getQuotaById(id: number): Observable<ApiResponse<Quota>> {
    return this.http.get<ApiResponse<Quota>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create quota request
   */
  createQuota(data: FormData): Observable<ApiResponse<Quota>> {
    return this.http.post<ApiResponse<Quota>>(this.apiUrl, data);
  }

  /**
   * Update quota
   */
  updateQuota(id: number, data: FormData): Observable<ApiResponse<Quota>> {
    return this.http.put<ApiResponse<Quota>>(`${this.apiUrl}/${id}`, data);
  }

  /**
   * Upload quota document
   */
  uploadDocument(quotaId: number, document: FormData): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/${quotaId}/documents`, document);
  }

  /**
   * Delete quota document
   */
  deleteDocument(quotaId: number, documentId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${quotaId}/documents/${documentId}`);
  }
}
